import { db } from '@/plugins/firebase';
import * as Koji from 'koji-lang';

async function getTranscriptions(entryId: string): Promise<firebase.firestore.QuerySnapshot> {
    return await db.collection('transcriptions').where('entryId', '==', entryId).orderBy('index', 'asc').get();
}

async function getEntry(entryId: string): Promise<firebase.firestore.DocumentSnapshot> {
    return await db.collection('entries').doc(entryId).get();
}

function downloadBase64(filename: string, base64: string) {
    try {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;base64,' + base64);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    } catch (err) {
        console.error(err);
        alert("ファイルのダウンロードに失敗しました");
    }
}


function download(filename: string, base64: string) {
    try {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + base64);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    } catch (err) {
        console.error(err);
        alert("ファイルのダウンロードに失敗しました");
    }
}

export async function downloadDocx(entryId: string) {
    const entry = await getEntry(entryId);
    const label = entry.data().label;
    const list = await getTranscriptions(entryId);
    let text = "";
    let idx = 1;
    list.forEach(doc => {
        const t = doc.data();
        text += `
        【コマ${idx}/${list.size}】
        `;
        text += t.text;
        idx++;
    });
    const result = Koji.parse(text);
    const base64 = await Koji.convertToDocx(result.ast, 'base64');
    downloadBase64(label + ".docx", base64);
}

export async function downloadXML(entryId: string) {
    const entry = await getEntry(entryId);
    const label = entry.data().label;
    const list = await getTranscriptions(entryId);
    let text = "";
    list.forEach(doc => {
        const t = doc.data();
        text += t.text;
    });
    const result = Koji.parse(text);
    const xml = await Koji.convertToTEI(result.ast);
    download(label + ".xml", encodeURIComponent(xml));
}

export async function downloadHTML(entryId: string) {
    const entry = await getEntry(entryId);
    const label = entry.data().label;
    const list = await getTranscriptions(entryId);
    let text = "";
    list.forEach(doc => {
        const t = doc.data();
        text += t.text;
    });
    const result = Koji.parse(text);
    const html = await Koji.convertToHTML(result.ast);
    download(label + ".html", encodeURIComponent(html));
}

export async function downloadLaTeX(entryId: string) {
    const entry = await getEntry(entryId);
    const label = entry.data().label;
    const list = await getTranscriptions(entryId);
    let text = "";
    list.forEach(doc => {
        const t = doc.data();
        text += t.text;
    });
    const result = Koji.parse(text);
    const html = await Koji.convertToLaTeX(result.ast);
    download(label + ".tex", encodeURIComponent(html));
}

export async function downloadText(entryId: string) {
    const entry = await getEntry(entryId);
    const label = entry.data().label;
    const list = await getTranscriptions(entryId);
    let text = "";
    list.forEach(doc => {
        const t = doc.data();
        text += t.text;
    });
    download(label + ".txt", encodeURIComponent(text));
}
